// extracted by mini-css-extract-plugin
export default {"container":"FailureIBAN_container__Xf441","title":"FailureIBAN_title__Aj8n3","paragraph":"FailureIBAN_paragraph__X2l3I","buttonContainer":"FailureIBAN_buttonContainer__Z-D+D"};